export const ADMIN_REQUEST = "@@adminReducer/ADMIN_REQUEST";
export const ADMIN_SUCCESS = "@@adminReducer/ADMIN_SUCCESS";
export const ADMIN_FAIL = "@@adminReducer/ADMIN_FAIL";
export const ADMIN_LOGOUT = "@@adminReducer/ADMIN_LOGOUT";